import { useCallback } from 'react';
import { useRequest } from '@Hooks/useRequest';
import { API } from '@Services';

interface DueDiligenceFieldsCompleteResponse {
  has_filled_in_due_diligence_fields: boolean;
}

export const useCheckDueDiligenceFieldsComplete = () => {
  const [fetch, response] = useRequest<DueDiligenceFieldsCompleteResponse>();

  const checkDueDiligenceFieldsComplete = useCallback(
    (organizationId: number) =>
      fetch(API.paths.due_diligence_fields_complete(organizationId), 'get'),
    [fetch],
  );

  return [checkDueDiligenceFieldsComplete, response] as const;
};
